export default __webpack_public_path__ + "static/media/sum2.292e9490.png";